module.exports = __webpack_public_path__ + "static/media/icon-dashboard-selected.2044b16e.svg";